import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import useIsMobile from '../../hooks/useIsMobile'

function LandingNavigation ({ scrollToSection }) {
  const navigate = useNavigate()
  const { isMobile } = useIsMobile()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const handleScroll = (sectionId) => {
    scrollToSection(sectionId)
    setMobileMenuOpen(false)
  }

  return (
    <nav className='lp-landing-nav'>
      <div className='lp-landing-nav-content'>
        <div className='lp-landing-brand'>
          {isMobile ? (
            <h2 style={{ paddingLeft: '1rem' }}>EngKnowledge</h2>
          ) : (
            <h2>Engineers Knowledge Base</h2>
          )}
        </div>
        {isMobile ? (
          <>
            <button
              className='lp-mobile-menu-toggle'
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label='Menü öffnen'
            >
              {mobileMenuOpen ? (
                <CloseIcon sx={{ fontSize: 28 }} />
              ) : (
                <MenuIcon sx={{ fontSize: 28 }} />
              )}
            </button>
            {mobileMenuOpen && (
              <div className='lp-mobile-menu'>
                <a
                  href='#features'
                  onClick={(e) => {
                    e.preventDefault()
                    handleScroll('features')
                  }}
                >
                  Features
                </a>
                <a
                  href='#pricing'
                  onClick={(e) => {
                    e.preventDefault()
                    handleScroll('pricing')
                  }}
                >
                  Preise
                </a>
                <a
                  href='#contact'
                  onClick={(e) => {
                    e.preventDefault()
                    handleScroll('contact')
                  }}
                >
                  Kontakt
                </a>
                <button onClick={() => navigate('/login')} className='lp-btn-login'>
                  Anmelden
                </button>
              </div>
            )}
          </>
        ) : (
          <div className='lp-landing-nav-links'>
            <a
              href='#features'
              onClick={(e) => {
                e.preventDefault()
                handleScroll('features')
              }}
            >
              Features
            </a>
            <a
              href='#pricing'
              onClick={(e) => {
                e.preventDefault()
                handleScroll('pricing')
              }}
            >
              Preise
            </a>
            <a
              href='#contact'
              onClick={(e) => {
                e.preventDefault()
                handleScroll('contact')
              }}
            >
              Kontakt
            </a>
            <button onClick={() => navigate('/login')} className='lp-btn-login'>
              Anmelden
            </button>
          </div>
        )}
      </div>
    </nav>
  )
}

export default LandingNavigation

